import { useEffect } from 'react';

type DebounceContext = {
  handler: EventListener;
  clearTimeout: () => void;
};

const debounce = (fn: EventListener, ms: number = 0): DebounceContext => {
  if (!ms) {
    return {
      handler: fn,
      clearTimeout: () => undefined
    };
  }

  let timeout: ReturnType<typeof setTimeout>;

  const handler = function (this: unknown, ...args: [evt: Event]) {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), ms);
  };

  return {
    handler,
    clearTimeout: () => clearTimeout(timeout)
  };
};

export const useWindowEvent = (
  event: keyof WindowEventMap,
  fn: EventListener,
  debounceTime?: number,
  deps: React.DependencyList = []
) => {
  useEffect(() => {
    const context = debounce(fn, debounceTime);
    window.addEventListener(event, context.handler);

    return () => {
      context.clearTimeout();
      window.removeEventListener(event, context.handler);
    };
  }, deps);
};
